import React from 'react'

const Poster = ({
  isPlaying = false
}) => {
  return (
    <div 
      className={`
        ${!isPlaying ? 'opacity-100' : ''}
        ${isPlaying? 'opacity-0 transition-opacity duration-1000 ease-out' : ''}
      `}
      style={{
        transform: 'scale(1.1)',
        backgroundImage: 'url(/media/fussy/landing-image.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: 2,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        height: '100vh',
        width: '100vw'
      }} />
  )
}

export default Poster